module.exports = __webpack_public_path__ + "static/media/image-feedback-success.0f155f6a.png";